import React from "react";
import { Route, Routes } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import "./custom.css";
import { Theme } from "@commonwealthdevelopment/web-ui-component-library";
import { ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthorization } from "./contexts/AuthorizationContext";
import ErrorPage from "./pages/Error/ErrorPage";
import ProtectedRoute from "./components/Route/ProtectedRoute";

const App = () => {
  const { groups } = useAuthorization();

  return groups.length === 0 ? (
    <ErrorPage
      title="Unauthorized"
      message="You don't have permissions to access the application"
    />
  ) : (
    <Theme theme="light">
      <Routes>
        {AppRoutes.map((route, index) => {
          const { element, ...rest } = route;
          return (
            <Route
              key={index}
              {...rest}
              element={
                <ProtectedRoute groups={rest.groups}>{element}</ProtectedRoute>
              }
            />
          );
        })}
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Bounce}
      />
    </Theme>
  );
};

export default App;
